<template src="./index.html">
</template>
<script>
import {getdata} from './data.js'
import dbsx from './dbsx/index.vue'
import wdtx from './wdtx/index.vue'

export default {

  name: 'todo',
  components: {
    dbsx,
    wdtx
  },
  data: function () {
    return {
      headlist: getdata().headlist,
      chooseindex: 0
    };
  },
  created() {
  },
  methods: {
    forchooseindex(e) {
      this.chooseindex = e
    }
  }
};
</script>


<style scoped lang="less">
@import url("./index.less");
</style>
